<template>
  <Card>
    <template #title="">
      <div class="p-d-flex p-justify-between">
        ข้อมูลพนักงาน
        <div>
          <Button
            label="Download Excel"
            icon="pi pi-download"
            class="p-button-success p-button-outlined"
            @click="onDownloadExcel"
          ></Button>
          <BackButton class="p-ml-2"></BackButton>
        </div>
      </div>
    </template>
    <template #content="">
      <div class="p-grid" v-if="screen.employee">
        <div class="p-col-12">
          <div class="p-d-flex p-dir-col p-align-center">
            <div class="clip-circle"><img :src="screen.photo" /></div>
            <span style="font-size: 2rem; font-weight: bold">{{
              `${screen.employee.id} : ${screen.employee.prename}${screen.employee.name} ${screen.employee.surname}`
            }}</span>
          </div>
        </div>
        <div class="p-col-12">
          <DataTable
            :value="screen.documents"
            class="p-datatable-sm"
            paginator
            rows="10"
          >
            <template #header="">การอบรมที่เข้าร่วม</template>
            <template #empty="">ไม่พบข้อมูลการอบรม</template>
            <template #footer="">
              ข้อมูลทั้งหมด {{ screen.documents?.length ?? 0 }} รายการ
            </template>
            <Column header="ID" field="id" sortable></Column>
            <Column
              header="หลักสูตร"
              field="course.description"
              sortable
            ></Column>
            <Column
              header="ประเภท"
              field="course.courseType.description"
              sortable
            ></Column>
            <Column header="วันที่" field="startDate" sortable>
              <template #body="props">
                {{ formatAppDate(props.data.startDate) }} -
                {{ formatAppDate(props.data.endDate) }}
              </template>
            </Column>
            <Column header="รูปแบบ" field="trainingTypeDescription" sortable>
            </Column>
          </DataTable>
        </div>
        <div class="p-col-12">
          <DataTable
            :value="screen.positions"
            class="p-datatable-sm"
            paginator
            rows="10"
          >
            <template #header=""
              >เอกสารพนักงานใหม่ / โอนย้าย / เลื่อนตำแหน่ง</template
            >
            <template #empty="">ไม่พบข้อมูล</template>
            <template #footer="">
              ข้อมูลทั้งหมด {{ screen.positions?.length ?? 0 }} รายการ
            </template>
            <Column header="ID" field="id" sortable></Column>
            <Column
              header="ประเภท"
              field="positionTypeDescription"
              sortable
            ></Column>
            <Column header="วันที่" field="documentDate" sortable>
              <template #body="props">
                {{ formatAppDate(props.data.documentDate) }}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { defineComponent, reactive, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import {
  Employee,
  TrainingAssessment,
  GetIndividualEmployeeRequest,
  GetIndividualEmployeeResponse,
  TrainingDocument,
  PositionDocument,
  DownloadEmployeeHistoryRequest,
} from "@/types";
import { saveAs } from "file-saver";

export default defineComponent({
  name: "EmployeeScreen",
  setup() {
    const {
      setLoading,
      axios,
      success,
      error,
      route,
      formatAppDate,
    } = usePlugin();

    const screen = reactive<{
      employee: Employee | null;
      documents: TrainingDocument[] | null;
      positions: PositionDocument[] | null;
      photo: string | null;
    }>({
      employee: null,
      documents: null,
      positions: null,
      photo: null,
    });

    const onDownloadExcel = async () => {
      if (screen.employee === null) {
        error("ไม่พบข้อมูลพนักงานไม่สามารถ download ได้");
        return;
      }
      setLoading(true);
      try {
        const result = await axios.post(
          "api/v1/services/employee/download",
          {
            employeeId: screen.employee.id,
          } as DownloadEmployeeHistoryRequest,
          { responseType: "blob" }
        );
        saveAs(result.data);
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const loadEmployee = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetIndividualEmployeeResponse>(
          "api/v1/services/employee",
          {
            id: route.params.id,
          } as GetIndividualEmployeeRequest
        );
        screen.employee = result.data.employee;
        screen.documents = result.data.trainingDocuments;
        screen.positions = result.data.positionDocuments;
        screen.photo = result.data.photo;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      await loadEmployee();
    });
    return {
      formatAppDate,
      onDownloadExcel,
      screen,
    };
  },
});
</script>

<style scoped>
.clip-circle {
  width: 10rem;
  max-width: 10rem;
  height: 10rem;
  max-height: 10rem;
  overflow: hidden;
  margin: 2rem;
}

.clip-circle img {
  clip-path: circle(5rem at 5rem 5rem);
  /*border-radius: 50%;*/
  width: 10rem;
  max-width: 10rem;
}
</style>
